<template>
  <InformationIcon />

  <div class="as-d-flex as-flex-column as-box-match-info">
    <div class="as-item as-d-flex as-align-items-center">
      <div class="as-icon">
        <img
          :src="
            match?.unique_tournament?.logo ||
            getImgUrlBySport(
              'competition',
              match?.unique_tournament?.id ?? match.unique_tournament_id
            )
          "
          class="as-icon"
          width="37"
          height="37"
        />
      </div>
      <div class="as-info">
        <div class="as-name">Giải đấu</div>
        <div class="as-nation">{{ match?.unique_tournament?.name ?? "-" }}</div>
      </div>
    </div>
    <div class="as-item as-d-flex as-align-items-center">
      <div class="as-icon">
        <IconTournamentTime />
      </div>
      <div class="as-info">
        <div class="as-name">Thời gian thi đấu</div>
        <div class="as-nation">{{ showMatchTime(match.match_time) }}</div>
      </div>
    </div>
    <div class="as-item as-d-flex as-align-items-center">
      <div class="as-icon">
        <IconTournamentVenue />
      </div>
      <div class="as-info">
        <div class="as-name">Địa điểm</div>
        <div class="as-nation">{{ match?.country?.name ?? "-" }}</div>
      </div>
    </div>
    <div class="as-item as-d-flex as-align-items-center">
      <div class="as-icon">
        <IconTournamentCourt />
      </div>
      <div class="as-info">
        <div class="as-name">Sân thi đấu</div>
        <div class="as-nation">{{ match?.venue?.name ?? "-" }}</div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { defineProps, computed } from "vue";
import InformationIcon from "~src/components/matches/InformationIcon.vue";
import StatsEnum from "~src/enums/tennis/StatsEnum";
import IconTournamentCourt from "~src/components/icons/IconTournamentCourt.vue";
import IconTournamentTime from "~src/components/icons/IconTournamentTime.vue";
import IconTournamentVenue from "~src/components/icons/IconTournamentVenue.vue";

interface IProps {
  match: any;
}

const props = withDefaults(defineProps<IProps>(), {});

const showMatchTime = computed(() => (timestamp: string | number) => {
  const timeValue =
    typeof timestamp === "string" ? parseInt(timestamp) : timestamp;

  const date = new Date(timeValue * 1000);

  const day = date.getDate().toString().padStart(2, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Tháng tính từ 0
  const year = date.getFullYear();
  const hours = date.getHours().toString().padStart(2, "0");
  const minutes = date.getMinutes().toString().padStart(2, "0");

  return `${day}/${month}/${year} ${hours}:${minutes}`;
});

const convertCourtType = computed(() => (group_id: number) => {
  const groupType: { [key: number]: string } = StatsEnum.groupType;

  return groupType[group_id] || "-";
});
</script>

<script lang="ts">
export default {};
</script>
